module.exports = __webpack_public_path__ + "static/media/radish.2a6c3c6d.png";